import { useMemo } from 'react';

import { stripAndDecodeHtml } from '@/utility/stripHtml';

interface IStrippedHtmlProps {
  text: string;
}

/**
 * Renders a long-text description field with HTML tags stripped and entities decoded.
 * Uses useMemo to avoid re-running stripAndDecodeHtml on every render.
 */
export const StrippedHtml = ({ text }: IStrippedHtmlProps) => {
  return <>{useMemo(() => stripAndDecodeHtml(text), [text])}</>;
};
